
import React, { useEffect, useState } from "react";

import { fetchAPI } from "@/utility/NetworkUtils";
import {
  Button,
  Stack,
  TextField as MuiTextField,
  FormControlLabel,
  Switch,
  TextField,
  Card,
  CardContent,
  CardActions,
  CardMedia,
  Typography,
  Grid,
  CircularProgress
} from "@mui/material"
import ReceivingListTrackingNumberForm from "./ReceivingListTrackingNumberForm";
import { isJaguar, isSuperadmin, isClient } from "../../utility/UserUtils"
import { Tooltip } from 'react-tooltip'
import Modal from "react-modal";

import Fuse from 'fuse.js'
import { use } from "react";
import { Add } from "@mui/icons-material";
import ReceivingListForm from "./ReceivingListForm";

const CreateNewItemSearchModal = (props) => {
  const {
    user,
    open,
    renter, 
    onClose = () => {},
    loadItems = false,
    events=[],
    useAddInventory,
    disableAddNewItem = false,
    header = null,
    onItemSelect = null
  } = props
  const [ items , setItems ] = useState(props.items);
  const [ itemName, setItemName ] = useState("");
  const [ loading, setLoading ] = useState(false);
  const maxOptionsSeen = 8
  const [ seeMore, setSeeMore ] = useState(false);
  const [ addInventoryFormVisible, setAddInventoryFormVisible ] = useState(false);
  const [ addInventoryItem, setAddInventoryItem ] = useState(null);
  useEffect(() => {
    setItems(props.items)
  },[props.items])

  useEffect(() => {
    setAddInventoryFormVisible(false)
    setSeeMore(false)
  }, [open])

  useEffect(() => {
    if(user && isJaguar(user) && open && !useAddInventory) {
      onClose()
      window.location = renter ? `/inventory/${renter.id}/items/new` : `/management/items/new`
    }
  }, [user, renter, open, useAddInventory])

  useEffect(() => {
    if(loadItems && open) {
      loadItemsAsync()
    }
  },[loadItems, open])

  loadItemsAsync = async () => {
    setLoading(true)
    fetchAPI(`/webapi/renters/${renter.id}/items?view=quick_add_modal`, (json)=> {
      if (!json.errors) {
        setItems(json.items)
        setLoading(false)
      } else {
        console.log({
          errors: json.errors
        })
      }
    }, {});
  }
  
  const fuseOptions = {
    isCaseSensitive: false,
    // includeScore: false,
    // ignoreDiacritics: false,
    // shouldSort: true,
    // includeMatches: false,
    // findAllMatches: false,
    // minMatchCharLength: 1,
    // location: 0,
    // threshold: 0.6,
    // distance: 100,
    // useExtendedSearch: false,
    // ignoreLocation: false,
    // ignoreFieldNorm: false,
    // fieldNormWeight: 1,
    keys: [
      "name",
      "description"
    ]
  };

  const renderFoundItems = () => {
    const fuse = new Fuse(items||[], fuseOptions);

    if(itemName && itemName.length > 0) {
      if(loading) {
        return (
          <div className="text-center">
            <CircularProgress />
            <br/>
            <h2> Loading...</h2>
          </div>
        );
      }
      let searchedItems = fuse.search(itemName)
      const searchItemsCount = searchedItems.length
      if(!seeMore) {
        searchedItems = searchedItems.slice(0, maxOptionsSeen)
      }
      if(searchedItems.length > 0) {
        return (
          <div>
          <h2>
            Select your item
          </h2>
          <div className="row" style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap"
          }}>
            {searchedItems.map(x => renderCard(x.item))}
          </div>
          {searchItemsCount > maxOptionsSeen ? (
            <div
              className="inline-block"
              onClick={() => setSeeMore(!seeMore)}
            >
              {seeMore ? "See less" : "See more"}
            </div>
          ) : null}
          </div>
        )
      }else {
        return (
          <div>
            No Existing Items Found
          </div>
        )
      }
    }
  }

  const openEditItemPage = (item) => {
    if(onItemSelect) {
      onItemSelect(item)
      return
    }
    //Open Item in new tab
    if(item.renter_id) {
      const url = `/inventory/${item.renter_id}/items/${item.id}/edit`
      window.open(url, '_blank');
    } else if(renter && renter.id != 'all') {
      const url = `/inventory/${renter.id}/items/${item.id}/edit`
      window.open(url, '_blank');
    } else {
      const url = `/management/items/${item.id}/edit`
      window.open(url, '_blank');
    }
  }

  const renderCard = (item) => {
    return (
      <div className="col-xs-12 col-sm-6 col-md-3 mb-4 cursor-pointer" onClick={()=>{
        openEditItemPage(item)
      }}>
        <Card sx={{ maxWidth: 600, width: "100%", height: "100%"}}>
          <CardMedia
            sx={{ height: 140 }}
            image={(item.active_image||{}).image}
            title="green iguana"
          />
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              {item.name}
            </Typography>
          </CardContent>
        </Card>
      </div>
    )
  }

  const renderCreateNewButton = () => {
    if(disableAddNewItem) {
      return null
    }
    if(itemName && itemName.length > 0) {
      return (
        <div>
          <Button
            href={renter ? `/inventory/${renter.id}/items/new` : `/management/items/new`}
            variant="contained"
          >
            Can't Find Your Item? Create a New One
          </Button>
        </div>
      )
    }else {
      return (
        <>
          <Tooltip
            id="create-new-item-tooltip"
            place="top"
          >
            Please try searching for your item before continuing.
          </Tooltip>
        <div
          
        >
          <div
            className="inline-block"
            data-tooltip-id="create-new-item-tooltip" 
          >
          <Button
            onClick={() => {}}
            disabled
            variant="contained"
            
          >
            Can't Find Your Item? Create a New One
          </Button>
          </div>
        </div>
        </>
      )
    }
  }

  const renderHeader = () => {
    if(header){
      return header
    }
    return (
      <h1>Let's Find Your Item</h1>
    )
  }

  return (
    <Modal
      className="react-modal inventory-modal add-form-modal"
      overlayClassName="react-modal-overlay"
      isOpen={open && (!isJaguar(user) || useAddInventory)}
      onRequestClose={onClose}
    >
      {addInventoryFormVisible ? (
        <ReceivingListForm
          user={user}
          item={addInventoryItem}
          events={events}
          onCancel={onClose}
          onSubmit={(json)=>{
            onClose(json)
          }}
        /> 
      ):(
        <Stack
          direction="column"
          spacing={2}
        >
          {renderHeader()}
          <TextField
            label="Item Name"
            placeholder="Start by entering your items name"
            variant="outlined"
            value={itemName}
            onChange={e => setItemName(e.target.value)}
          />

          {renderFoundItems()}
          {renderCreateNewButton()}
        </Stack>
      )}
    </Modal>
  )
}

export default CreateNewItemSearchModal